import { memo } from 'react';

import { InfoIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

import { ASSIGNMENT_TEXT_CLASSES } from '../../constants/assignment-text';

interface AssignmentDuplicatePhantomProps {
  duplicateOffset: number;
  startOffset: number;
  duplicateDuration: number;
  phantomBackgroundColor: string;
  projectColorBorder: string;
  isOneDayAssignment: boolean;
  isCompact: boolean;
  assignmentTitle: string;
  oneDayFragmentIconSize: number;
}

export const AssignmentDuplicatePhantom = memo(
  ({
    duplicateOffset,
    startOffset,
    duplicateDuration,
    phantomBackgroundColor,
    projectColorBorder,
    isOneDayAssignment,
    isCompact,
    assignmentTitle,
    oneDayFragmentIconSize,
  }: AssignmentDuplicatePhantomProps) => {
    return (
      <div
        className="assignment pointer-events-none absolute top-0 flex h-full items-center rounded-[100px] opacity-70"
        style={{
          left: `${duplicateOffset - startOffset}rem`,
          width: `${duplicateDuration}rem`,
          backgroundColor: phantomBackgroundColor,
          border: `1px dashed ${projectColorBorder}`,
        }}
      >
        <div
          className={cn('sticky top-0 w-fit truncate pl-3 text-white', ASSIGNMENT_TEXT_CLASSES, {
            'pl-2.5': isOneDayAssignment,
            'pl-2': isOneDayAssignment && isCompact,
          })}
        >
          {isOneDayAssignment ? (
            <InfoIcon className="-ml-1" size={oneDayFragmentIconSize} />
          ) : (
            assignmentTitle
          )}
        </div>
      </div>
    );
  }
);

AssignmentDuplicatePhantom.displayName = 'AssignmentDuplicatePhantom';
